import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";
import PayTRIframe from "./PayTRIframe"; // make sure this component renders iframe from token

function BookingForm({ pitch, weeklyBlockedTimes }) {
  const [pitchSlot, setPitchSlot] = useState([]);
  const [slotIndex, setSlotIndex] = useState(0);
  const [userPitches, setUserPitches] = useState([]);
  const [slotTime, setSlotTime] = useState("");
  const [updatedPitch, setUpdatedPitch] = useState();
  const [bookedTime, setBookedTime] = useState([]);
  const [isUnavailable, setIsUnavailable] = useState(false);
  const [iframeToken, setIframeToken] = useState("");
  const [payDepositOnly, setPayDepositOnly] = useState(false);

  const {
    bookingData,
    setBookingData,
    user,
    token,
    backendURL,
    pending,
    setShowAlert,
    userNote,
    setUserNote,
    setAlertMessage,
    setIsErr,
    setPending,
    setPendingBookingID,
    navigate,
  } = useContext(PitchContext);

  const daysOfWeek = ["PZ", "PZT", "SL", "ÇRB", "PRB", "CM", "CMT"];
  const monthsInTurkish = [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara",
  ];

  const getPitch = async () => {
    try {
      const response = await axios.post(
        backendURL + `pitch/get/${pitch.slug}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setUpdatedPitch(response.data.pitch);
        return response.data.pitch;
      }
    } catch (err) {
      console.log(err);
      setIsErr(true);
      setAlertMessage(
        err.response?.data?.message || "Saha alınırken hata oluştu"
      );
      setShowAlert(true);
    }
  };

  const handleBooking = async () => {
    if (isUnavailable) {
      setShowAlert(true);
      setAlertMessage("Bu saat başka biri tarafından rezerve edildi.");
      return;
    }

    if (!bookingData.time) {
      setShowAlert(true);
      setAlertMessage("Lütfen bir saat seçin");
      return;
    }

    setPending(true);
    const latestPitch = await getPitch();
    const temp = latestPitch.bookings.map((item) => item.bookingData.id);

    if (temp.includes(bookingData.id)) {
      setPending(false);
      setShowAlert(true);
      setAlertMessage("Bu saat başka bir kullanıcının sepetinde.");
      return;
    }

    const bookingDataCopy = structuredClone(bookingData);
    const bookingPayload = {
      userID: user._id,
      userName: user.fullname,
      userEmail: user.email,
      pitchName: pitch.name,
      userNote,
      address: pitch.location.address,
      pitchID: pitch._id,
      bookingData: JSON.stringify(bookingDataCopy),
      status: "confirmed",
      totalPrice: payDepositOnly ? pitch.deposit : pitch.price,
      paymentStatus: pitch.ownerID._id === user._id ? "paid" : "unpaid",
    };
    try {
      const response = await axios.post(
        `${backendURL}booking/create`,
        bookingPayload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.success) {
        if (pitch.ownerID._id === user._id) {
          setShowAlert(true);
          setIsErr(false);
          setAlertMessage("Saha başarı ile rezerve edildi.");
          navigate("/profil");
        } else {
          setPendingBookingID(response.data.booking._id);
          localStorage.setItem("bookingID", response.data.booking._id);
          localStorage.setItem(
            "bookingTime",
            response.data.booking.bookingData.dateTime
          );

          const payTRRes = await axios.post(
            backendURL + "payment/paytr-payment",
            {
              user_name: user.fullname,
              email: user.email,
              slug: pitch.slug,
              user_address: pitch.location.address,
              user_phone: user.phone || "05381234567",
              payment_amount:
                parseInt(payDepositOnly ? pitch.deposit : pitch.price) * 100,
            }
          );
          localStorage.setItem("userNote", userNote);
          localStorage.setItem("iframeToken", payTRRes.data.iframe_token);
          localStorage.setItem("orderID", payTRRes.data.orderID);
          localStorage.setItem("pitchID", pitch._id);
          localStorage.setItem(
            "price",
            payDepositOnly ? pitch.deposit : pitch.price
          );
          localStorage.setItem("ownerID", pitch.ownerID._id);
          navigate("/odeme/" + pitch.slug);
        }
      } else {
        setAlertMessage("Rezervasyon oluşturulamadı");
        setShowAlert(true);
      }
    } catch (err) {
      setShowAlert(true);
      setAlertMessage(
        err.response?.data?.message || "İşlem sırasında hata oluştu"
      );
      console.error(err);
    } finally {
      setPending(false);
    }
  };

  const handleDate = (item, isUn) => {
    setSlotTime(item.time);
    setBookingData(item);
    setIsUnavailable(isUn);
  };

  const getAvailableSlot = () => {
    setPitchSlot([]);
    const today = new Date();
    let slotsAdded = 0;

    for (let i = 0; slotsAdded < 7; i++) {
      const currentDate = new Date(today);
      currentDate.setDate(today.getDate() + i);

      let startTime = new Date(currentDate);
      startTime.setHours(0, 0, 0, 0);

      const now = new Date();
      if (i === 0) {
        if (now.getMinutes() > 0 || now.getSeconds() > 0) {
          now.setHours(now.getHours() + 1);
          now.setMinutes(0, 0, 0);
        }
        startTime = now;
      }

      const endTime = new Date(currentDate);
      endTime.setDate(currentDate.getDate() + 1);
      endTime.setHours(0, 0, 0, 0);

      const timeSlots = [];
      while (startTime < endTime) {
        const formattedTime = startTime.toLocaleTimeString("tr-TR", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        timeSlots.push({
          id: `${new Date(startTime)}${formattedTime}`,
          dateTime: new Date(startTime),
          time: formattedTime,
        });
        startTime.setHours(startTime.getHours() + 1);
      }

      if (timeSlots.length > 0) {
        setPitchSlot((prev) => [...prev, timeSlots]);
        slotsAdded++;
      }
    }
  };

  useEffect(() => {
    const temp = pitch.bookings.map((item) => item.bookingData.id);
    setBookedTime(temp);
  }, [pitch, pending]);

  useEffect(() => {
    getAvailableSlot();
  }, []);

  useEffect(() => {
    if (token) {
      setUserPitches(user.pitches.map((item) => item._id));
    }
  }, [token]);

  return (
    <div className="">
      <div className="mt-6 font-medium text-gray-700">
        <div className="flex justify-center">
          <div className="flex gap-3 overflow-x-auto scrollbar-thin scrollbar-thumb-[#6ca87e] scrollbar-track-gray-100 pb-2 w-full max-w-2xl">
            {pitchSlot.length &&
              pitchSlot.map((item, index) => (
                <div
                  onClick={() => setSlotIndex(index)}
                  className={`flex flex-col items-center justify-center w-20 h-20 rounded-full cursor-pointer transition-all duration-200 shadow-sm ${
                    slotIndex === index
                      ? "bg-[#6ca87e] text-white"
                      : "bg-white border border-gray-200 hover:bg-gray-50"
                  }`}
                  key={index}
                >
                  <p className="text-sm font-semibold">
                    {item[0] && daysOfWeek[item[0].dateTime.getDay()]}
                  </p>
                  <p className="text-lg">{item[0]?.dateTime.getDate()}</p>
                  <p className="text-xs">
                    {item[0] && monthsInTurkish[item[0].dateTime.getMonth()]}
                  </p>
                </div>
              ))}
          </div>
        </div>

        <h2 className="grid place-items-center mt-8 text-xl">
          Başlangıç Saati
        </h2>

        <div className="flex justify-center mt-2">
          <div className="flex flex-wrap gap-3 overflow-x-auto scrollbar-thin scrollbar-thumb-[#6ca87e] scrollbar-track-gray-100 pb-2 w-full max-w-2xl">
            {pitchSlot.length &&
              pitchSlot[slotIndex]?.map((item, index) => {
                const dayOfWeek = item.dateTime.getDay();
                const isDateUnavailable = bookedTime.includes(item.id);
                const isWeeklyUnavailable = weeklyBlockedTimes?.[
                  dayOfWeek
                ]?.includes(item.time);
                const isUnavailable = isDateUnavailable || isWeeklyUnavailable;

                return (
                  <button
                    key={index}
                    onClick={() =>
                      !isUnavailable && handleDate(item, isUnavailable)
                    }
                    className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 shadow-sm cursor-pointer
                      ${
                        isUnavailable
                          ? "bg-red-500 text-white cursor-not-allowed"
                          : item.time === slotTime
                          ? "bg-[#6ca87e] text-white"
                          : "bg-white text-gray-600 border border-gray-300 hover:bg-gray-100"
                      }`}
                    disabled={isUnavailable}
                  >
                    {item.time}
                  </button>
                );
              })}
          </div>
        </div>

        <div className="flex justify-center mt-6">
          <div className="w-full max-w-2xl">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Saha Sahibine Not (isteğe bağlı)
            </label>
            <textarea
              value={userNote}
              onChange={(e) => setUserNote(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent resize-y"
              rows="4"
              placeholder="Saha sahibi için özel isteklerinizi veya notlarınızı ekleyin..."
            />
          </div>
        </div>

        <div className="flex justify-center mt-4">
          <div className="w-full max-w-2xl">
            <label className="flex items-center text-sm font-medium text-gray-700">
              <input
                type="checkbox"
                checked={payDepositOnly}
                onChange={(e) => setPayDepositOnly(e.target.checked)}
                className="mr-2 h-4 w-4 text-[#6ca87e] focus:ring-[#6ca87e] border-gray-300 rounded"
              />
              Sadece kaporayı ödemek istiyorum
            </label>
          </div>
        </div>

        {token ? (
          <div className="flex justify-center mt-10 gap-5">
            {user.verified ? (
              <button
                disabled={pending}
                onClick={handleBooking}
                className="bg-[#6ca87e] text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-[#5a906a] transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                Kirala
              </button>
            ) : (
              <Link
                to="/eposta-dogrula"
                className="bg-[#6ca87e] text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-[#5a906a] transition-all duration-300 transform hover:scale-105"
              >
                E-postanızı Doğrulayın
              </Link>
            )}
          </div>
        ) : (
          <div className="flex justify-center mt-10">
            <Link
              to="/giris-yap"
              className="bg-[#6ca87e] text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-[#5a906a] transition-all duration-300 transform hover:scale-105"
            >
              Rezervasyon Yapmak İçin Giriş Yapın
            </Link>
          </div>
        )}

        {iframeToken && (
          <div className="mt-10 max-w-3xl mx-auto">
            <PayTRIframe iframeToken={iframeToken} />
          </div>
        )}
      </div>
    </div>
  );
}

export default BookingForm;
